module.exports = __webpack_public_path__ + "static/img/P3F-Stamp-RGB-white.6d1fcb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/P3F-Stamp-RGB-white.png
// module id = eu4Y
// module chunks = 1